function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useLocalStorageState, useDebounceFn } from 'ahooks';
import queryString from "query-string";
import qs from "qs";
import { useEffect } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import { ModelDefinition } from "./..";
import castAttributesFromModel, { reverseCastFromDefinition } from "../ModelDefinition/castAttributesFromDefinition";
var getPairs = function getPairs(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.entries(obj).reduce(function (pairs, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value) {
      if (_typeof(value) === 'object')
        // @ts-ignore
        pairs.push.apply(pairs, _toConsumableArray(getPairs(value, [].concat(_toConsumableArray(keys), [key]))));else
        // @ts-ignore
        pairs.push([[].concat(_toConsumableArray(keys), [key]), value]);
    }
    return pairs;
  }, []);
};
var useSearchFilters = function useSearchFilters(key, options) {
  var _ref3 = options || {},
    _ref3$updateLocation = _ref3.updateLocation,
    updateLocation = _ref3$updateLocation === void 0 ? false : _ref3$updateLocation,
    _ref3$enabled = _ref3.enabled,
    enabled = _ref3$enabled === void 0 ? true : _ref3$enabled,
    _ref3$debug = _ref3.debug,
    debug = _ref3$debug === void 0 ? false : _ref3$debug,
    _ref3$definition = _ref3.definition,
    definition = _ref3$definition === void 0 ? undefined : _ref3$definition,
    _ref3$defaultSearch = _ref3.defaultSearch,
    defaultSearch = _ref3$defaultSearch === void 0 ? {} : _ref3$defaultSearch,
    history = _ref3.history;
  if (!enabled) return {};
  var _useLocalStorageState = useLocalStorageState("".concat(key, "-page"),
    // @ts-ignore
    1),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    page = _useLocalStorageState2[0],
    setPage = _useLocalStorageState2[1];
  var _useLocalStorageState3 = useLocalStorageState("".concat(key, "-per-page"),
    // @ts-ignore
    25),
    _useLocalStorageState4 = _slicedToArray(_useLocalStorageState3, 2),
    perPage = _useLocalStorageState4[0],
    setPerPage = _useLocalStorageState4[1];
  var _useLocalStorageState5 = useLocalStorageState(key, {
      defaultValue: defaultSearch
    }),
    _useLocalStorageState6 = _slicedToArray(_useLocalStorageState5, 2),
    s = _useLocalStorageState6[0],
    setSearch = _useLocalStorageState6[1];
  var search = s || {};
  useEffect(function () {
    if (updateLocation) {
      var parsed = qs.parse(location.search.replace('?', ''));
      if (parsed) {
        var _values = Object.keys(parsed).map(function (k) {
          return parsed[k];
        }).filter(Boolean);
        // @ts-ignore
        if (_values.length > 0) {
          if (definition) setSearch(_objectSpread({}, castAttributesFromModel(definition, parsed)));
          // @ts-ignore
          else setSearch(_objectSpread({}, parsed));
        }
      }
    }
  }, []);
  var handleSearch = function handleSearch(values) {
    var nextSearch = _objectSpread(_objectSpread({}, s), values);
    var locationSearch = _objectSpread(_objectSpread({}, s), values);
    if (definition) {
      var searchModel = new ModelDefinition(definition);
      nextSearch = searchModel.parse(nextSearch);
    }
    if (debug) console.table({
      parameters: nextSearch,
      original: values,
      definition: definition
    });
    setSearch(nextSearch);
    if (updateLocation) {
      var _window$location;
      var nestedParams = getPairs(locationSearch).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          _ref5$ = _toArray(_ref5[0]),
          key0 = _ref5$[0],
          keysRest = _ref5$.slice(1),
          value = _ref5[1];
        return "".concat(key0).concat(keysRest.map(function (a) {
          return "[".concat(a, "]");
        }).join(''), "=").concat(value);
      }).join('&');
      setPage(1);
      var pathname = ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) + '?' + nestedParams;
      if (history) history.push(pathname);
    }
  };
  var onReset = function onReset() {
    setSearch({});
    if (updateLocation && history) history.push(window.location.pathname);
  };
  var onPageChange = function onPageChange(page, pageSize) {
    setPage(perPage !== pageSize ? 1 : page);
    setPerPage(pageSize);
    if (updateLocation) {
      var _window$location2;
      var searchToStringify = Object.keys(search || {}).reduce(function (acc, attributeName) {
        // @ts-ignore
        if (dayjs.isDayjs(search[attributeName])) acc[attributeName] = search[attributeName].format('YYYY-MM-DD');
        // @ts-ignore
        if (moment.isMoment(search[attributeName])) acc[attributeName] = search[attributeName].format('YYYY-MM-DD');
        // @ts-ignore
        else acc[attributeName] = search[attributeName];
        return acc;
      }, {});
      var pathname = ((_window$location2 = window.location) === null || _window$location2 === void 0 ? void 0 : _window$location2.pathname) + '?' + queryString.stringify(_objectSpread(_objectSpread({}, searchToStringify), {}, {
        page: page,
        perPage: pageSize
      }), {
        arrayFormat: 'bracket',
        skipNull: true
      });
      if (history) history.replace(pathname);
    }
  };
  var _useDebounceFn = useDebounceFn(handleSearch, {
      wait: 500
    }),
    onSearch = _useDebounceFn.run;
  return {
    // @ts-ignore
    search: definition ? reverseCastFromDefinition(definition, search) : search,
    page: page ? parseInt(page) : 1,
    perPage: perPage ? parseInt(perPage) : 10,
    onPageChange: onPageChange,
    onReset: onReset,
    set: setSearch,
    onChange: onSearch
  };
};
export default useSearchFilters;